import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import client from "@/lib/glossyApi";

const box = "w-full bg-transparent border border-cream/30 px-4 py-3 font-sans text-sm text-cream placeholder:text-cream/35 focus:outline-none focus:border-gloss-gold transition-colors";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", business_name: "", message: "", website: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.includes("@") || form.message.trim().length < 5) {
      toast.error("Your name, a valid email and a message, please.");
      return;
    }
    setBusy(true);
    try {
      await client.post("/contact", form);
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "That didn't send — try again.");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-ink text-cream" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-10 sm:py-16">
        <Link to="/" className="font-serif text-3xl tracking-tight hover:text-gloss-gold transition-colors" data-testid="contact-wordmark">S/ME</Link>
        <p className="overline text-gloss-gold mt-2 mb-10">Write to the desk</p>
        {sent ? (
          <div data-testid="contact-sent">
            <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-4">Received.</h1>
            <p className="font-sans text-base text-cream/70 max-w-md leading-relaxed">Your note is on the editor's desk — we reply to every message, usually within a working day.</p>
            <p className="font-mono text-[10px] opacity-40 mt-8">
              <Link to="/" className="underline hover:text-gloss-gold">Read the magazine</Link> · <Link to="/join" className="underline hover:text-gloss-gold">See membership</Link> · <Link to="/call" className="underline hover:text-gloss-gold">Book a call</Link>
            </p>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3">Talk to us.</h1>
            <p className="font-sans text-base text-cream/60 mb-10 max-w-md leading-relaxed">Questions about membership, a story tip, or anything else — it lands straight on the editor's desk.</p>
            <form onSubmit={submit} className="space-y-4 max-w-xl" data-testid="contact-form">
              <div className="grid sm:grid-cols-2 gap-4">
                <input value={form.name} onChange={set("name")} placeholder="Your name" className={box} data-testid="contact-name" />
                <input value={form.email} onChange={set("email")} type="email" placeholder="Your email" className={box} data-testid="contact-email" />
              </div>
              <input value={form.business_name} onChange={set("business_name")} placeholder="Your business (optional)" className={box} data-testid="contact-business" />
              <input value={form.website} onChange={set("website")} className="hidden" tabIndex={-1} autoComplete="off" aria-hidden="true" />
              <textarea value={form.message} onChange={set("message")} rows={6} placeholder="Your message" className={box} data-testid="contact-message" />
              <button type="submit" disabled={busy} className="overline text-[11px] px-6 py-3 bg-gloss-gold text-ink hover:bg-cream transition-colors disabled:opacity-50" data-testid="contact-submit">
                {busy ? "Sending…" : "Send to the desk"}
              </button>
            </form>
            <p className="font-mono text-[10px] opacity-40 mt-10">
              Ready to talk it through instead? <Link to="/call" className="underline hover:text-gloss-gold">Book a discovery call</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
